var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({ref:"input",attrs:{"type":"text","inputmode":"numeric","autocomplete":"off"},domProps:{"value":_vm.display},on:{"keypress":_vm.onKeypress,"input":_vm.onInput}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }